module.exports = __webpack_public_path__ + "static/media/20190826_175638.thumbnail.79e19946.png";